import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { loadDashboardSettings } from '../../redux/actions/dashboardAction';
import { IconHouse, IconEdit, IconSummary, IconReports, IconAssignments, IconClasses, IconSubscriptions, IconAccount, IconDatabase } from './theme';
import { toArray } from '../../Utils';

const IconComp=({title})=>{
    if(title==='Home') return <IconSummary/>;
    if(title==='Reports') return <IconReports/>;
    if(title==='Assignments') return <IconAssignments/>;
    if(title==='Classes') return <IconClasses/>;
    if(title==='Students') return <IconClasses/>;
    if(title==='Subscriptions') return <IconSubscriptions/>;
    if(title==='Database') return <IconDatabase/>;
    if(title==='Account') return <IconAccount/>;
    if(title==='Spelling Lists') return <IconEdit/>;
    return <></>;
};
const NavButton = ({linkTo, title, currentTopic, url}) =>{
    let variantType = (title == 'Spelling Lists') ? 'warning' :(currentTopic) ? 'info': 'outline-secondary';   
    return ( <>
        {linkTo &&
            <Link to={linkTo}>         
                <Button style={{margin:'10px'}} variant={variantType}><IconComp title={title}/> {title} </Button>
            </Link>}
        {url &&
            <a href={url}>         
                <Button style={{margin:'10px'}} variant={variantType}><IconComp title={title}/> {title} </Button>
            </a>}            
    </>);
};

NavButton.propTypes = {
    linkTo: PropTypes.string,
    title: PropTypes.string,
    currentTopic: PropTypes.bool,
    url: PropTypes.string
};

const DynamicNav = ({buttons}) => 
    <Row> 
        {buttons.map((buttonInfo, i) => 
            <NavButton key={i} title={buttonInfo.title} linkTo={buttonInfo.linkTo} currentTopic={buttonInfo.currentTopic} url={buttonInfo.url} />
        )}
    </Row>;

DynamicNav.propTypes = {
    buttons: PropTypes.array
};

const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);
const isCleverPaidLibMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Library");
const isCleverSyncMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Sync");
const isCleverSharedFreeLibMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Shared");
const isCleverSharedPaidLibMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Sync_Lib");

const StaticNav = ({currentTopic, database, isAdmin, onSwitchClick}) =>{
    // console.log('database',database);
    if(isAdmin){
        if(!database['getAllClasses'] || !database['getAllClasses'].data)
            return <></>;
        if(toArray(database['getAllClasses'].data).length === 0)
            return( <><DynamicNav buttons={[{title:'Classes', linkTo:'/users', currentTopic: (currentTopic==='Users')}]}/></>);
            
        if(sessionStorage.getItem('productionPath')!=='0000000000000000'){
            if(isLTIMode()){
                return(
                    <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Classes', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Subscriptions', linkTo:'/subscriptions', currentTopic: (currentTopic==='Subscriptions')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')},
                    {title:'Spelling Lists', url:`https://editor.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                ]}/>);    
            }
            else{
                return(
                    <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                    {title:'Classes', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Subscriptions', linkTo:'/subscriptions', currentTopic: (currentTopic==='Subscriptions')},
                    {title:'Database', linkTo:'/databases', currentTopic: (currentTopic==='Database')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')},
                    {title:'Spelling Lists', url:`https://editor.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                    // {title:'Spelling Lists', url:`http://contentcreator.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                ]}/>);
            }
        }
        else{
            if(isLTIMode()){
                return(
                    <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Classes', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Subscriptions', linkTo:'/subscriptions', currentTopic: (currentTopic==='Subscriptions')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')}
                ]}/>);
            }
            else{
                return(
                    <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                    {title:'Classes', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Subscriptions', linkTo:'/subscriptions', currentTopic: (currentTopic==='Subscriptions')},
                    {title:'Database', linkTo:'/databases', currentTopic: (currentTopic==='Database')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')}
                ]}/>);
            }
        }

    }
    else{
        //database['getAllClasses'].data[classKey].students
        if(!database['getStudentsForClass'] || !database['getStudentsForClass'].data)
            return <></>;
        if(toArray(database['getStudentsForClass'].data).length === 0)
            return( <><DynamicNav buttons={[{title:'Students', linkTo:'/users', currentTopic: (currentTopic==='Users')}]}/></>);
        if(sessionStorage.getItem('productionPath')!=='0000000000000000'){

            if(isCleverSharedPaidLibMode())
                return(
                <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                    {title:'Students', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')},
                    {title:'Subscriptions', url:`https://online.essentialskills.com/sso/clever/library/fullteacher/subscription.php?ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&teacherID=${sessionStorage.getItem('teacherID')}`, currentTopic: (currentTopic==='Subscriptions')},
                    {title:'Spelling Lists', url:`https://editor.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')},
                    {title:'Free Phonics', url:`https://online.essentialskills.com/sso/clever/library/teacherlogin.php?ID=${database['getCustomer'].data['URL_NUM']}&URL_NUM=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&classID=${sessionStorage.getItem('userID')}&teacherID=${sessionStorage.getItem('teacherID')}`, currentTopic: (currentTopic==='Free Phonics')}
                ]}/>);                
            else if(isCleverSyncMode())
                return(
                    <DynamicNav buttons={[
                        {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                        {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                        {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                        {title:'Students', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                        {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')},
                        {title:'Spelling Lists', url:`https://editor.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                        //{title:'Spelling Lists', url:`http://contentcreator.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                    ]}/>);
            else if(isCleverSharedFreeLibMode())
                return(
                    <DynamicNav buttons={[
                        {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                        {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                        {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                        {title:'Students', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                        {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')},                        
                        {title:'Spelling Lists', url:`https://editor.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')},
                        {title:'Free Phonics', url:`https://online.essentialskills.com/sso/clever/library/teacherlogin.php?ID=${database['getCustomer'].data['URL_NUM']}&URL_NUM=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&classID=${sessionStorage.getItem('userID')}&teacherID=${sessionStorage.getItem('teacherID')}`, currentTopic: (currentTopic==='Free Phonics')}
                        // {title:'Free Phonics', url:`https://online.essentialskills.com/sso/clever/library/teacherlogin.php?ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&teacherID=${sessionStorage.getItem('teacherID')}`, currentTopic: (currentTopic==='Free Phonics')},
                        //{title:'Spelling Lists', url:`http://contentcreator.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                    ]}/>);
            else
            return(
                <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                    {title:'Students', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')},
                    {title:'Spelling Lists', url:`https://editor.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                    //{title:'Spelling Lists', url:`http://contentcreator.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=${sessionStorage.getItem('productionPathStatic')}`, currentTopic: (currentTopic==='Spelling Lists')}
                ]}/>);
        }
        else{
            if(isCleverPaidLibMode())
                return(
                <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                    {title:'Students', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')},
                    {title:'Subscriptions', url:`https://online.essentialskills.com/sso/clever/library/fullteacher/subscription.php?ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&teacherID=${sessionStorage.getItem('teacherID')}`, currentTopic: (currentTopic==='Subscriptions')},
                    {title:'Spelling Lists', url:`https://editor.essentialskills.com?T=A&ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&productionPath=1fe17f23202eaea80000`, currentTopic: (currentTopic==='Spelling Lists')},
                    {title:'Free Phonics', url:`https://online.essentialskills.com/sso/clever/library/teacherlogin.php?ID=${database['getCustomer'].data['URL_NUM']}&URL_NUM=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&classID=${sessionStorage.getItem('userID')}&teacherID=${sessionStorage.getItem('teacherID')}`, currentTopic: (currentTopic==='Free Phonics')}
                ]}/>);
            else
                return(
                <DynamicNav buttons={[
                    {title:'Home', linkTo:'/summary', currentTopic: (currentTopic==='Home')},
                    {title:'Reports', linkTo:'/reports', currentTopic: (currentTopic==='Reports')},
                    {title:'Assignments', linkTo:'/assignments', currentTopic: (currentTopic==='Assignments')},
                    {title:'Students', linkTo:'/users', currentTopic: (currentTopic==='Users')},
                    {title:'Account', linkTo:'/profile', currentTopic: (currentTopic==='Account')}
                ]}/>);   
        }

    }
};

StaticNav.propTypes = {
    currentTopic: PropTypes.string,
    isAdmin: PropTypes.bool.isRequired,
    onSwitchClick: PropTypes.func
};

const mapStateToProps = state => {
    return {
        database: state.genericReducer,
        isAdmin: (state.dashboardReducer.login === 'Admin')
   };
};

const mapDispatchToProps = dispatch => {
    return {
      onSwitchClick: id => {
        dispatch(loadDashboardSettings({login: id}));
      }
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(StaticNav);